import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "w-full h-2 rounded bg-gray-200" }

interface Props {
    progress: number
    barColor: string
    progressSuffix?: string
    isProgressNumberVisible?: boolean
    progressNumberColor?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsProgressBar',
  props: {
    progress: {},
    barColor: {},
    progressSuffix: {},
    isProgressNumberVisible: { type: Boolean },
    progressNumberColor: { default: "text-primary-color-700" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isProgressNumberVisible)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["text-sm font-semibold", _ctx.progressNumberColor])
        }, _toDisplayString(_ctx.progress) + _toDisplayString(_ctx.progressSuffix), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["h-full rounded", _ctx.barColor]),
        style: _normalizeStyle(`width: ${_ctx.progress}%`)
      }, null, 6)
    ])
  ]))
}
}

})